module.exports = __webpack_public_path__ + "static/media/LoadImg.5632f659.webp";